// convex/lib/sites/slug.ts
//
// La dirección (`slug`) de un sitio público. Sirve en `/s/<slug>` y, si está
// configurado el dominio de sitios, también como subdominio
// (`<slug>.<VITE_SITES_BASE_DOMAIN>`). Sin dependencias: lo usan el esquema
// (site_shape.ts) y la detección del host en el navegador (lib/sites/host.ts).

export const SITE_SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const SITE_SLUG_MIN = 3;
export const SITE_SLUG_MAX = 48;

/**
 * Direcciones que chocarían con subdominios de la infraestructura (la app,
 * la API, el correo, los entornos de prueba, la documentación…). Ningún
 * sitio puede usarlas y el navegador nunca las trata como sitio.
 */
export const SITE_RESERVED_SLUGS = [
  "www",
  "app",
  "api",
  "erp",
  "admin",
  "mail",
  "smtp",
  "dev",
  "dev-preview",
  "preview",
  "staging",
  "status",
  "docs",
  "help",
  "soporte",
  "static",
  "cdn",
  "assets",
  "s",
  "sitios",
  "heskala",
] as const;

const RESERVED = new Set<string>(SITE_RESERVED_SLUGS);

export const isReservedSiteSlug = (slug: string): boolean => RESERVED.has(slug.trim().toLowerCase());

/** Forma válida de dirección (sin mirar si está reservada). */
export const isSiteSlugShape = (slug: string): boolean =>
  slug.length >= SITE_SLUG_MIN && slug.length <= SITE_SLUG_MAX && SITE_SLUG_RE.test(slug);
